import { ComponentType, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { RoutesWrapper } from '@/components/RoutesWrapper';

export const createWrappedElement = (Component: ComponentType<any>) => (
  <>
    <RoutesWrapper>
      <Suspense fallback={<LoadingSpinner />}>
        <Component />
      </Suspense>
    </RoutesWrapper>
  </>
);

export const createProtectedElement = (Component: ComponentType<any>) => (
  <RoutesWrapper>
    <ProtectedRoute>
      <Suspense fallback={<LoadingSpinner />}>
        <Component />
      </Suspense>
    </ProtectedRoute>
  </RoutesWrapper>
);

export const createRedirectElement = (to: string) => <Navigate to={to} replace />;
